import { render, staticRenderFns } from "./listNew.vue?vue&type=template&id=04f4807d&scoped=true"
import script from "./listNew.vue?vue&type=script&lang=js"
export * from "./listNew.vue?vue&type=script&lang=js"
import style0 from "./listNew.vue?vue&type=style&index=0&id=04f4807d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f4807d",
  null
  
)

export default component.exports